import React, { useEffect } from 'react';
import { composer } from '../../../component-decorators/composer';
import s from './finish-setup.scss';
import ChevronLeftLarge from 'wix-ui-icons-common/ChevronLeftLarge';
import { config } from '../../../config';
import { finishInstallCTA } from '../../../common/utils';
import { useMarketplaceStore, } from '../../../component-decorators/with-marketplace-store';
import { Button, Heading, Text, TextButton } from 'wix-style-react';
import { useConfigContext } from '../../../config-context';
import { biLogger } from '../../../bi';
export var dtoToFinishSetupProps = function (app, version) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    if ((_a = app) === null || _a === void 0 ? void 0 : _a.webSolutionBase) {
        return {
            appName: (_c = (_b = app) === null || _b === void 0 ? void 0 : _b.webSolutionBase) === null || _c === void 0 ? void 0 : _c.name,
            appDefId: (_e = (_d = app) === null || _d === void 0 ? void 0 : _d.webSolutionBase) === null || _e === void 0 ? void 0 : _e.id,
            appTeaser: (_g = (_f = app) === null || _f === void 0 ? void 0 : _f.webSolutionBase) === null || _g === void 0 ? void 0 : _g.teaser,
            appIconUrl: (_j = (_h = app) === null || _h === void 0 ? void 0 : _h.webSolutionBase) === null || _j === void 0 ? void 0 : _j.icon,
            appVersion: (_k = app) === null || _k === void 0 ? void 0 : _k.installedVersion,
        };
    }
    return {
        appName: (_m = (_l = app) === null || _l === void 0 ? void 0 : _l.baseInfo) === null || _m === void 0 ? void 0 : _m.name,
        appDefId: (_p = (_o = app) === null || _o === void 0 ? void 0 : _o.baseInfo) === null || _p === void 0 ? void 0 : _p.id,
        appTeaser: (_r = (_q = app) === null || _q === void 0 ? void 0 : _q.baseInfo) === null || _r === void 0 ? void 0 : _r.teaser,
        appIconUrl: (_t = (_s = app) === null || _s === void 0 ? void 0 : _s.baseInfo) === null || _t === void 0 ? void 0 : _t.icon,
        appVersion: version,
    };
};
export var FinishSetup = composer()
    .withMarketplaceStore()
    .compose(function (_a) {
    var appName = _a.appName, appDefId = _a.appDefId, appTeaser = _a.appTeaser, appIconUrl = _a.appIconUrl, appVersion = _a.appVersion;
    // tslint:disable-next-line: react-hooks-nesting
    var marketplaceStore = useMarketplaceStore();
    // tslint:disable-next-line: react-hooks-nesting
    var configContext = useConfigContext();
    // tslint:disable-next-line: react-hooks-nesting
    useEffect(function () {
        // tslint:disable-next-line: no-floating-promises
        finishInstallCTA(appDefId, appVersion, marketplaceStore.installedApps, configContext, false);
    }, []);
    return (React.createElement("div", { className: s.finishSetup, "data-testid": 'finish-setup' },
        React.createElement(FinishSetupHeader, { appName: appName }),
        React.createElement(AppCard, { appName: appName, appDefId: appDefId, appTeaser: appTeaser, appIconUrl: appIconUrl, appVersion: appVersion, configContext: configContext })));
});
var sendAddPendingAppBi = function (appId, msid) {
    biLogger
        .__deprecated__91({
        app_id: appId,
        msid: msid,
        pending_source: 'manage_apps',
    })
        .catch(function (e) { return console.log(e); });
};
var FinishSetupHeader = composer()
    .withTranslation()
    .compose(function (_a) {
    var appName = _a.appName, t = _a.t;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: s.manageAppsLink },
            React.createElement(TextButton, { size: "medium", prefixIcon: React.createElement(ChevronLeftLarge, null), onClick: config.goToManageApps }, t('finishSetup.goto'))),
        React.createElement("div", { className: s.header },
            React.createElement(Heading, { appearance: 'H1', children: t('finishSetup.title'), dataHook: 'finish-setup-title' }),
            React.createElement(Text, { children: t('finishSetup.subtitle', { appName: appName }), dataHook: 'finish-setup-subtitle' }))));
});
var AppCard = composer()
    .withTranslation()
    .withMarketplaceStore()
    .compose(function (_a) {
    var appName = _a.appName, appDefId = _a.appDefId, appTeaser = _a.appTeaser, appIconUrl = _a.appIconUrl, t = _a.t, appVersion = _a.appVersion, marketplaceStore = _a.marketplaceStore, configContext = _a.configContext;
    return (React.createElement("div", { className: s.appCard },
        React.createElement("img", { src: appIconUrl
                ? appIconUrl
                : config.marketplaceStaticsUrl + "/assets/images/logo-placeholder.svg", "data-testid": 'finish-setup-app-card-icon' }),
        React.createElement("div", { className: s.column },
            React.createElement(Heading, { appearance: 'H3', children: appName, dataHook: 'finish-setup-app-card-title' }),
            React.createElement(Text, { children: appTeaser, dataHook: 'finish-setup-app-card-subtitle' })),
        React.createElement(Button, { className: s.addToSite, children: t('finishSetup.addToSite'), dataHook: 'finish-setup-app-add-to-site', onClick: function () {
                sendAddPendingAppBi(appDefId, marketplaceStore.metaSiteId);
                finishInstallCTA(appDefId, appVersion, marketplaceStore.installedApps, configContext, true);
            } })));
});
//# sourceMappingURL=finish-setup.js.map